export default __webpack_public_path__ + "google-signup_nl.svg";